import { type ICampaignScheduleType } from 'entities/Campaign'

export const campaignScheduleTypeTitle: Record<ICampaignScheduleType, string> = {
  immediately: 'Immediately',
  delay: 'Delay',
  date: 'Date',
  date_field: 'Date & Time',
}
